import { ProductDetailsContext } from '@components';
import { Box, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';
import { useContext, useMemo } from 'react';

// STYLES
//--------
const DescriptionBox = styled(Box)`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.01em;
  color: #1c1c1c;

  margin-bottom: 16px;

  ${breakpoints.up('md')} {
    margin-bottom: 24px;
  }
`;

const UspBox = styled(Box)`
  margin: 0;
  margin-bottom: 16px;
  margin-left: 24px;
  padding: 0;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.01em;
  color: #000000;
`;

export const ProductUsp = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const productUseKeys = useMemo(
    () => [
      'productUseArea1',
      'productUseArea2',
      'productUseArea3',
      'productUseArea4',
      'productUseArea5',
    ],
    []
  );
  const { description, productDescription } = product;
  const hasDescription = description || productDescription;
  return (
    <Box>
      {hasDescription && <DescriptionBox>{productDescription || description}</DescriptionBox>}
      <UspBox component='ul'>
        {productUseKeys.map(
          (key) =>
            product[key] &&
            product[key].value && (
              <Box key={key} component='li'>
                {product[key]?.value}
              </Box>
            )
        )}
      </UspBox>
    </Box>
  );
};
